import { forwardRef, InputHTMLAttributes } from 'react';
import { cln } from '../lib/utils';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(
  ({ label, className, ...props }, ref) => {
    const id = crypto.randomUUID();
    return (
      <label htmlFor={id} className={cln('flex items-center gap-2', className)}>
        <input type="checkbox" ref={ref} {...props} />
        {label}
      </label>
    );
  },
);

Checkbox.displayName = 'Checkbox';
